import { ThunkType } from "../../../../../core/store/reducers";
import { getAnnualSecurityReport } from "../api/getAnnualSecurityReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../annualSecurityDataSlice";

export const downloadOrdersReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.securityCommission.annualSecurity;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getAnnualSecurityReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "AnnualSecurityTrading.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
